const state = () => ({
    openModal: false,
    component: 'DefaultModalContent',
    showHeader: true, 
    title: '',
    content: '',
    slotWrapClass: 'slot', 
});

const getters = {
    getModalContent : state => state.content
};

const mutations = {
    UPDATE_MODALSTATE(state, payload){
        if(state.title != ''){ state.title = '' }
        if(state.title != ''){ state.slotWrapClass = 'slot' }
        state = Object.assign(state, payload)
    },
};

const actions = {

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}